import { CheckIcon } from '@heroicons/react/24/outline';
import { AUDIT_OUTCOME_LABELS } from '@utils/auditActions';

// Eine Quelle für Status-Label und -Farbe. Vorher lag in jeder der drei
// Admin-Listen eine eigene Ternär-Kaskade, und die Liste zeigte den rohen
// Wert („active"), während das Filtermenü daneben „Aktiv" anbot.

const TONES = {
  green: 'bg-green-50 text-green-700 ring-green-600/20',
  red: 'bg-red-50 text-red-700 ring-red-600/20',
  yellow: 'bg-yellow-50 text-yellow-800 ring-yellow-600/20',
  blue: 'bg-blue-50 text-blue-700 ring-blue-600/20',
  gray: 'bg-gray-50 text-gray-600 ring-gray-500/10',
  fuchsia: 'bg-fuchsia-50 text-fuchsia-700 ring-fuchsia-600/20',
};

const CARD_STATUS = {
  active: { label: 'Aktiv', tone: 'green' },
  blocked: { label: 'Blockiert', tone: 'red' },
  demo: { label: 'Demo', tone: 'gray' },
  unclaimed: { label: 'Nicht beansprucht', tone: 'fuchsia' },
  ordered: { label: 'Bestellt', tone: 'yellow' },
};

const USER_STATUS = {
  active: { label: 'Aktiv', tone: 'green' },
  blocked: { label: 'Blockiert', tone: 'red' },
  pending: { label: 'Ausstehend', tone: 'yellow' },
};

const ORDER_STATUS = {
  Ausstehend: { label: 'Ausstehend', tone: 'yellow' },
  Bezahlt: { label: 'Bezahlt', tone: 'blue' },
  Geliefert: { label: 'Geliefert', tone: 'green', icon: true },
  Fehlgeschlagen: { label: 'Fehlgeschlagen', tone: 'red' },
  Abgebrochen: { label: 'Abgebrochen', tone: 'red' },
};

const ORDER_SOURCE = {
  web: { label: 'Web', tone: 'gray' },
  manual: { label: 'Manuell', tone: 'blue' },
  company: { label: 'Firma', tone: 'fuchsia' },
};

const AUDIT_OUTCOME = {
  success: { label: AUDIT_OUTCOME_LABELS.success, tone: 'green' },
  failure: { label: AUDIT_OUTCOME_LABELS.failure, tone: 'yellow' },
  denied: { label: AUDIT_OUTCOME_LABELS.denied, tone: 'red' },
};

const MAPS = {
  card: CARD_STATUS,
  user: USER_STATUS,
  order: ORDER_STATUS,
  orderSource: ORDER_SOURCE,
  auditOutcome: AUDIT_OUTCOME,
};

/** Label eines Status — auch ausserhalb des Badges nutzbar (Filtermenüs). */
export const statusLabel = (type, status) =>
  MAPS[type]?.[status]?.label ?? status ?? '—';

/**
 * Optionen für ein Filter-Dropdown, inklusive „Alle"-Eintrag mit leerem Wert.
 */
export const statusFilterOptions = (type, allLabel = 'Alle') => [
  { value: '', label: allLabel },
  ...Object.entries(MAPS[type] ?? {}).map(([value, { label }]) => ({
    value,
    label,
  })),
];

const StatusBadge = ({ type, status, className = '' }) => {
  if (!status) return <span className="text-sm text-gray-400">—</span>;

  const config = MAPS[type]?.[status] ?? { label: status, tone: 'gray' };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset ${
        TONES[config.tone]
      } ${className}`}
    >
      {config.label}
      {config.icon && <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" />}
    </span>
  );
};

export default StatusBadge;
